import React from "react";
import PropTypes from "prop-types";

import { Modal } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import ConfirmCancel from "./confirm-cancel";
import { v4 as uuidv4 } from "uuid";

import delete_icon from "assets/img/delete.svg";

class TemplateEPLView extends React.Component {
  static propTypes = {
    projectId: PropTypes.string,
    templateId: PropTypes.string,
    getCustomTemplateDetail: PropTypes.func,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    customTemplateList: PropTypes.object,
    onSave: PropTypes.func,
    getDefaultTemplate: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      name: "Untitled template",
      sections: [],
      disclaimer: "",
      titleConfig: {
        field1: { enabled: false, value: "" },
        field2: { enabled: false, value: "" },
        field3: { enabled: false, value: "" }
      },
      openConfirmModal: false,
      isSave: false,
    };
  }

  componentDidMount() {
    this.getCustomTemplateDetail();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.customTemplateList !== nextProps.customTemplateList) {
      const template = nextProps.customTemplateList;
      this.setState({
        id: this.props.templateId,
        name: template.name,
        sections: template.sections,
        disclaimer: template.disclaimer !== null ? template.disclaimer : "",
        titleConfig: {
          field1: { 
            enabled: template.isCheckedTitle1 || false, 
            value: template.title1 || "" 
          },
          field2: { 
            enabled: template.isCheckedTitle2 || false, 
            value: template.title2 || "" 
          },
          field3: { 
            enabled: template.isCheckedTitle3 || false, 
            value: template.title3 || "" 
          }
        }
      });
    }
  }

  onClose = () => {
    this.props.onClose();
  };

  onCloseAfterEdit = () => {
    this.props.onClose();
    this.props.getDefaultTemplate();
  };

  onCancelConfirmModal = () => {
    this.setState({
      openConfirmModal: false,
      isSave: false,
    });
  };

  getCustomTemplateDetail() {
    this.props.getCustomTemplateDetail({
      projectId: this.props.projectId,
      templateId: this.props.templateId,
    });
  }

  isInvalidTemplate() {
    const { sections } = this.state;

    if (sections.length === 0) {
      return true;
    }

    if (
      sections.some((s) => !s.items.some((i) => i.name && i.name.length > 0))
    ) {
      return true;
    }

    return false;
  }

  onAddNewSectionBtnClick = () => {
    let { sections } = this.state;

    sections.push({
      id: uuidv4(),
      items: [],
      name: "Untitled checklist",
    });

    this.setState({ openCustomTemplate: true, sections: sections });
  };

  toolTipDisclaimer() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>
          This disclaimer is put right above the signature section in the form.
        </span>
      </Tooltip>
    );
  }

  onEnterItemBtnClick = (sectionIndex) => {
    let { sections } = this.state;

    sections[sectionIndex].items.push({
      id: uuidv4(),
      name: null,
    });

    this.setState({ sections: sections });
  };

  onRemoveItem = (sectionIndex, index) => {
    let { sections } = this.state;

    sections[sectionIndex].items.splice(index, 1);
    this.setState({ sections: sections });
  };

  onRemoveSection = (sectionIndex) => {
    let { sections } = this.state;

    sections.splice(sectionIndex, 1);
    this.setState({ sections: sections });
  };

  onEditTemplateTitle = (value) => {
    this.setState({ name: value });
  };

  onEditDisclaimer = (value) => {
    this.state.disclaimer = value;
    this.setState({ disclaimer: this.state.disclaimer });
  };

  onEditSectionTitle = (index, value) => {
    let { sections } = this.state;

    sections[index].name = value;
    this.setState({ sections: sections });
  };

  onEditItemContent = (sectionIndex, index, value) => {
    let { sections } = this.state;

    sections[sectionIndex].items[index].name = value;
    this.setState({ sections: sections });
  };

  onEditTitleConfig = (field, value) => {
    let { titleConfig } = this.state;
    titleConfig[field].value = value;
    this.setState({ titleConfig: titleConfig });
  };

  onToggleTitleConfig = (field) => {
    let { titleConfig } = this.state;
    titleConfig[field].enabled = !titleConfig[field].enabled;
    if (!titleConfig[field].enabled) {
      titleConfig[field].value = "";
    }
    this.setState({ titleConfig: titleConfig });
  };

  renderSections = () => {
    const { sections } = this.state;

    return (
      sections &&
      sections
        .sort((a, b) => a.order - b.order)
        .map((section, index) => (
          <div key={section.id} className="custom-template-section-item">
            <div className="top-section">
              <div className="section-items">
                <div className="col-xs-11" style={{ top: "5px" }}>
                  <div className="custom-template-name">
                    <input
                      name={section.id}
                      className="form-control custom-template-name"
                      placeholder="Untitled checklist"
                      autoComplete="off"
                      maxLength="254"
                      value={section.name}
                      onBlur={() =>
                        section.name ||
                        this.onEditSectionTitle(index, "Untitled checklist")
                      }
                      onChange={(e) =>
                        this.onEditSectionTitle(index, e.target.value)
                      }
                    />
                  </div>
                </div>
                <div
                  className="col-xs-1"
                  style={{ lineHeight: "46px", textAlign: "center" }}
                >
                  <img
                    src={delete_icon}
                    style={{ width: 20, cursor: "pointer" }}
                    onClick={() => this.onRemoveSection(index)}
                  />
                </div>
              </div>
              {this.renderSectionItems(section, index)}
              <div className="bottom-section">
                <div className="col-xs-12">
                  <span onClick={() => this.onEnterItemBtnClick(index)}>
                    Enter item
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))
    );
  };

  renderSectionItems = (section, sectionIndex) => {
    if (section.items.length === 0) {
      return "";
    }

    return section.items
      .sort((a, b) => a.order - b.order)
      .map((item, index) => (
        <div key={item.id} className="bottom-section clearfix">
          <div style={{ top: 5 }} className="col-xs-1">
            <span>{index + 1}. </span>
          </div>
          <div className="col-xs-9" style={{ bottom: "10px", right: "10px" }}>
            <div className="item-section-edit">
              <textarea
                name={section.id + "|" + item.id}
                className="form-control"
                maxLength="254"
                value={item.name}
                onChange={(e) =>
                  this.onEditItemContent(sectionIndex, index, e.target.value)
                }
              />
            </div>
          </div>
          <div className="col-xs-2" style={{ lineHeight: "36px" }}>
            <img
              src={delete_icon}
              style={{ width: 16, cursor: "pointer" }}
              onClick={() => this.onRemoveItem(sectionIndex, index)}
            />
          </div>
        </div>
      ));
  };

  render() {
    const { disclaimer, name } = this.state;
    const isInvalidTemplate = this.isInvalidTemplate();

    return (
      <Modal centered="true" dialogClassName="template-eoc-dialog" show={true}>
        <div style={{ margin: 10 }}>
          <Modal.Header>
            <div className="container-fluid">
              <div className="title-custom-template row">
                <input
                  name="model"
                  className="form-control"
                  placeholder="Untitled template"
                  autoComplete="off"
                  maxLength="254"
                  value={name}
                  onBlur={() =>
                    name || this.onEditTemplateTitle("Untitled template")
                  }
                  onChange={(e) => this.onEditTemplateTitle(e.target.value)}
                />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row">
                <h5
                  style={{
                    fontWeight: "bolder",
                    color: "lightgray",
                    marginLeft: 5,
                  }}
                >
                  Title Configuration
                </h5>
                <div className="col-xs-12" style={{marginBottom: 10, display: "flex", alignItems: "center"}}>
                  <input type="checkbox" checked={this.state.titleConfig.field1.enabled}
                    onChange={() => this.onToggleTitleConfig("field1")} style={{marginRight: 10, width: 18, height: 18, cursor: "pointer"}} />
                  <input className="form-control" placeholder="Title 1" value={this.state.titleConfig.field1.value}
                    disabled={!this.state.titleConfig.field1.enabled}
                    onChange={(e) => this.onEditTitleConfig("field1", e.target.value)} />
                </div>
                <div className="col-xs-12" style={{marginBottom: 10, display: "flex", alignItems: "center"}}>
                  <input type="checkbox" checked={this.state.titleConfig.field2.enabled}
                    onChange={() => this.onToggleTitleConfig("field2")} style={{marginRight: 10, width: 18, height: 18, cursor: "pointer"}} />
                  <input className="form-control" placeholder="Title 2" value={this.state.titleConfig.field2.value}
                    disabled={!this.state.titleConfig.field2.enabled}
                    onChange={(e) => this.onEditTitleConfig("field2", e.target.value)} />
                </div>
                <div className="col-xs-12" style={{marginBottom: 10, display: "flex", alignItems: "center"}}>
                  <input type="checkbox" checked={this.state.titleConfig.field3.enabled}
                    onChange={() => this.onToggleTitleConfig("field3")} style={{marginRight: 10, width: 18, height: 18, cursor: "pointer"}} />
                  <input className="form-control" placeholder="Title 3" value={this.state.titleConfig.field3.value}
                    disabled={!this.state.titleConfig.field3.enabled}
                    onChange={(e) => this.onEditTitleConfig("field3", e.target.value)} />
                </div>
              </div>
              <br />
              <div className="row">
                <h5
                  style={{
                    fontWeight: "bolder",
                    color: "lightgray",
                    marginLeft: 5,
                  }}
                >
                  Checklist Configuration
                </h5>
              </div>
              <div className="row">{this.renderSections()}</div>
              <div className="row">
                <button
                  onClick={this.onAddNewSectionBtnClick}
                  className="btn btn-primary btn-siteone-default"
                >
                  <span className="fa fa-plus icon" />
                  Add new checklist
                </button>
              </div>
              <br />
              <div className="row">
                <h5 style={{ fontWeight: "bolder", color: "lightgray" }}>
                  Text Configuration
                </h5>
                <div className="disclaimer">
                  <span>
                    Disclaimer{" "}
                    <OverlayTrigger
                      placement="right"
                      overlay={this.toolTipDisclaimer()}
                      delayHide={10}
                      delayShow={500}
                    >
                      <i className="fa fa-question-circle" />
                    </OverlayTrigger>
                  </span>
                  <div className="disclaimer-textarea">
                    <textarea
                      className="form-control"
                      name="disclaimer"
                      ref="disclaimer"
                      value={disclaimer}
                      style={{ height: 225 }}
                      maxLength="524288"
                      onChange={(e) => this.onEditDisclaimer(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-xs-12" style={{ textAlign: "left" }}>
                <button
                  onClick={() => this.onClose()}
                  className="btn btn-primary btn-siteone-default"
                >
                  Cancel
                </button>
                <button
                  onClick={() =>
                    this.setState({ isSave: true, openConfirmModal: true })
                  }
                  style={{ marginLeft: "20px" }}
                  className="btn btn-primary btn-siteone"
                  disabled={isInvalidTemplate}
                >
                  Save
                </button>
              </div>
            </div>
          </Modal.Footer>
          {this.state.openConfirmModal && (
            <ConfirmCancel
              isSave={this.state.isSave}
              isOpen={this.state.openConfirmModal}
              data={{
                id: this.state.id,
                name: this.state.name,
                sections: this.state.sections,
                disclaimer: this.state.disclaimer,
                IsCheckedTitle1: this.state.titleConfig.field1.enabled,
                IsCheckedTitle2: this.state.titleConfig.field2.enabled,
                IsCheckedTitle3: this.state.titleConfig.field3.enabled,
                ...(this.state.titleConfig.field1.enabled && this.state.titleConfig.field1.value && { Title1: this.state.titleConfig.field1.value }),
                ...(this.state.titleConfig.field2.enabled && this.state.titleConfig.field2.value && { Title2: this.state.titleConfig.field2.value }),
                ...(this.state.titleConfig.field3.enabled && this.state.titleConfig.field3.value && { Title3: this.state.titleConfig.field3.value }),
              }}
              templateId={this.props.templateId}
              onOk={this.onClose}
              onCancel={this.onCancelConfirmModal}
              onEditCustomTemplate={this.props.onSave}
              onCloseAfterSave={this.onCloseAfterEdit}
            />
          )}
        </div>
      </Modal>
    );
  }
}

export default TemplateEPLView;



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-epl-view.js